module.exports = __webpack_public_path__ + "a6707143c08357a98c345854736fb894.ttf";